import React from "react";
import { Col, DropdownButton, Dropdown, Image } from "react-bootstrap";
export default ({
  itemArray,
  value,
  onToggle,
  show,
  dropdownTitle,
  ishideArrow,
  dropdowndefaultValue,
  style,
  iconPre,
  titleAlign,
  dropdownTitleWithImage,
  disabled,
  onSelect,
  headtitleInUnder,
}) => {
  return (
    <Col
      lg={12}
      md={12}
      sm={12}
      xs={12}
      style={{
        padding: "0%",
        fontSize: style?.fontSize ? style.fontSize : "",
      }}
    >
      {dropdownTitle !== "" ? (
        <div
          className="commonDrop-head flex-between-center"
          style={{
            marginBottom: style?.titleheadMarginBottom
              ? style.titleheadMarginBottom
              : "",
            ...style?.headTitleStyle,
          }}
        >
          <div className="dropdowntitle">{dropdownTitle}</div>
          {dropdownTitleWithImage?.length ? (
            <div className="dropdowntitleimg">
              {dropdownTitleWithImage.map((img) => (
                <Image src={img} />
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        ""
      )}
      <div
        style={{
          height: style?.height ? style.height : "",
          marginBottom: style?.marginBottom ? style.marginBottom : "1rem",
        }}
      >
        <DropdownButton
          id="dropdown-basic-button"
          className={`commonDropdown ${disabled ? "disabled-style" : ""}`}
          show={show}
          disabled={disabled ? disabled : false}
          onToggle={onToggle}
          style={
            style?.dropdownParentStyle ? { ...style.dropdownParentStyle } : {}
          }
          title={
            <span
              className={`${
                titleAlign === "center"
                  ? "flex-center-center"
                  : "flex-between-center"
              }`}
              style={{ width: "100%", height: "100%" }}
            >
              <div
                style={{
                  ...style,
                  fontSize: style?.fontSize ? style?.fontSize : "",
                  color: style?.titleColor,
                }}
                className={`truncate ${
                  headtitleInUnder ? "flex-col-start" : "flex-center"
                }`}
              >
                {headtitleInUnder ? (
                  <div style={{ ...style?.headtitleInUnderStyle }}>
                    {headtitleInUnder}
                  </div>
                ) : (
                  ""
                )}
                {value?.image ? (
                  <Image src={value?.image} style={{ marginRight: "10px" }} />
                ) : iconPre ? (
                  <Image
                    src={iconPre}
                    style={{ marginRight: "10px" ,width: "22px" }}
                  />
                ) : (
                  ""
                )}
                {value?.dot ? "........" : ""}
                <div
                  style={{
                    // paddingTop: "4px",
                    color: "#495057",
                    fontSize: style?.fontSize ? style?.fontSize : "",
                    color: style?.color ? style?.color : "#898484",
                    fontFamily: style?.fontFamily
                      ? style?.fontFamily
                      : "OpenSans, Arial, sans-serif",
                  }}
                >
                  {value?.name
                    ? value.name
                    : dropdowndefaultValue
                    ? dropdowndefaultValue
                    : "No Selected"}
                </div>
              </div>
              {!ishideArrow ? (
                <Image
                  style={{
                    width: style?.arrowIconSize ? style?.arrowIconSize : "15px",
                  }}
                  src={require("./../../assets/icons/down-arrow.png")}
                />
              ) : (
                ""
              )}
            </span>
          }
        >
          {itemArray && itemArray.length ? (
            itemArray.map((items, index) => {
              return (
                <Dropdown.Item onClick={() => onSelect(items)} key={index}>
                  <div
                    className="flex-center common-para"
                    style={
                      {
                        // fontSize: "18px",
                        // color: "#878382",
                      }
                    }
                  >
                    {items.image ? (
                      <div
                        style={{
                          border: style?.imageItemBorder
                            ? style.imageItemBorder
                            : "",
                          height: "21px",
                          padding: "0px 5px",
                        }}
                        className="flex-center-center"
                      >
                        <Image src={items.image} />
                      </div>
                    ) : (
                      ""
                    )}
                    {items.dot ? (
                      <span
                        style={{
                          paddingBottom: "5px",
                          marginLeft: "15px",
                          marginRight: "10px",
                        }}
                      >
                        ........
                      </span>
                    ) : (
                      ""
                    )}
                    {items.name}
                  </div>
                </Dropdown.Item>
              );
            })
          ) : (
            <Dropdown.Item>No Data</Dropdown.Item>
          )}
        </DropdownButton>
      </div>
    </Col>
  );
};
